import { Component, computed, inject, Input, signal } from '@angular/core';
import { ReceiptComponent } from '../../user-protected/tax-payment/receipt/receipt.component';
import { CommonModule } from '@angular/common';
import { ObjectLiteral } from '../../../core/models/ObjectLiteral';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { BillsService } from '../../../core/services/bills.service';
import { injectQueryParams } from 'ngxtension/inject-query-params';
import { ReceiptData } from '../../../shared/models';

@Component({
  selector: 'app-receipt-verification',
  standalone: true,
  imports: [ReceiptComponent, CommonModule],
  templateUrl: './receipt-verification.component.html',
  styleUrl: './receipt-verification.component.css',
})
export class ReceiptVerificationComponent {
  billService = inject(BillsService);
  ref = injectQueryParams('ref');
  billReference = injectQueryParams('billReference');

  isInvoice = signal(false);

  billQueryResponse = injectQuery(() => {
    return {
      queryKey: ['single-bill', this.ref(), this.billReference()],
      queryFn: ({ queryKey }) => {
        const [, ref, billRef] = queryKey;
        return this.billService.getBill({
          billReference: ref || billRef,
        });
      },
      enabled: !!this.ref() || !!this.billReference(),
      retry: 1,
    };
  });

  isLoading = computed(() => {
    return (
      this.billQueryResponse.fetchStatus() === 'fetching' &&
      this.billQueryResponse.isPending()
    );
  });

  receiptData = computed<ReceiptData>(() => {
    const bill = this.billQueryResponse.data() as ObjectLiteral;
    const userData = this.billQueryResponse.data()?.userData?.user;
    const userAddress =
      this.billQueryResponse.data()?.userData?.userRegistration?.addressLine1;
    return {
      ...bill,
      billTo: {
        name: `${userData?.firstName} ${userData?.lastName}`,
        address: userAddress || '',
        email: `${userData?.email}`,
      },
      billFrom: {
        name: 'Kaduna State Internal Revenue Service',
        address: 'Kaduna State',
      },
      items: (bill?.bill?.billDetails || []).map((item: any) => ({
        id: item?.id,
        amount: item?.amount || 0,
        rate: item?.amount || 0,
        description: item?.description || '',
        quantity: 1,
        narration: item?.narration || '',
      })),
      totalAmount:
        (bill?.bill?.billDetails || []).reduce(
          (a: number, b: any) => a + b.amount,
          0,
        ) || 0,
    } as ReceiptData;
  });
}
